import { Button, List, NavBar, Ellipsis } from 'antd-mobile'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { getAppointmentDetail } from '../../redux/actions/appointment/appointment'
import queryString from 'query-string'
import { MessageError } from '../../component/Common/MessageError/MessageError'
import Loading from '../../component/Common/Loading/Loading'
import { AppointmentStatus } from '../../component/Appointments/AppointmentStatus'
import DateCard from '../../component/AppointmentDetail/DateCard'
import './AppointmentDetail.css'
import dayjs from 'dayjs'
import { convertMinsToHrsMins } from '../../utils/utility'
import { HeartTwoTone } from '@ant-design/icons'
import decodeHtmlEntities from '../../utils/UnexcapeString/UnexcapeString'
import { EditSOutline, DownFill } from 'antd-mobile-icons'
import AppointmentImages from '../../component/AppointmentDetail/AppoitmentImages'

// import { nationalFormatPhone } from '../../utils/FormatPhoneNumber/FormatPhoneNumber'

const AppointmentDetail = () => {
    const navigate = useNavigate();

    const navigateRef = useRef(navigate);

    useEffect(() => {
        navigateRef.current = navigate;
    }, [navigate]);


    const dispatch = useDispatch()
    const location = useLocation()

    const { error, message, loading, appointmentDetail } = useSelector(state => state.appointment)
    const { allowCreateAppointment } = useSelector(state => state.authenticate.user)
    // const [isHideClientPhoneNumber, setIsHideClientPhoneNumber] = useState(false)
    useEffect(() => {
        const queryObject = queryString.parse(location.search);
        dispatch(getAppointmentDetail(queryObject.aid)).then(result => {
            if (result?.status === 404) {
                navigateRef.current(-1);
            }
        });
    }, [dispatch, location.search]); // navigate not needed here

    useEffect(() => {
        MessageError(message, error)
    }, [error, message])

    if (!appointmentDetail || loading) {
        return <Loading />
    }

    return (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100vh', zIndex: 100, background: "white" }}>
            <div className="top-nav"  >
                <NavBar onBack={() => {
                    if (window.history.length > 2) {
                        navigate(-1);
                    } else {
                        navigate('/'); // fallback route
                    }
                }}>Appointment #{appointmentDetail.number}</NavBar>
            </div>
            <div style={{ padding: "20px" }}>
                <List style={{
                    '--padding-left': "0px",
                    '--padding-right': "0px",
                }}>
                    <List.Item
                        style={{ borderRight: "1px solid rgb(238, 240, 242)" }}
                        prefix={<DateCard date={appointmentDetail.date} />}

                    >
                        <h2 style={{ fontWeight: "bold", fontSize: "20px", }}>{appointmentDetail.clientName}</h2>
                        {allowCreateAppointment && appointmentDetail.phone && <div>
                            <div style={{ margin: "5px 0px" }}><span>•••• {appointmentDetail.phone?.slice(-4)}</span></div>
                        </div>}
                        {allowCreateAppointment && appointmentDetail.businessClient && appointmentDetail.businessClient.note && <div>
                            <Ellipsis
                                content={decodeHtmlEntities(appointmentDetail.businessClient.note)}
                                direction='end'
                                rows={2} // or however many lines you want to show before truncating
                                expandText={<DownFill />}
                                collapseText={<DownFill style={{ transform: 'rotate(180deg)', marginLeft: "5px" }} />}
                                style={{ color: '#d46b08', }}
                            />
                        </div>}
                        <AppointmentStatus status={appointmentDetail.status} />
                    </List.Item>
                </List>


                <div style={{ marginTop: 30, textAlign: "start" }}>

                    {appointmentDetail.services.map((service, index) => {
                        return (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'flex-start',
                                    justifyContent: 'space-around',
                                    marginBottom: 20,
                                    gap: 20,
                                }}
                            >
                                <div style={{ width: '80px', fontWeight: 'bold', fontSize: '16px' }}>
                                    {dayjs(service.start, "HH:mm").format('hh:mm a')}
                                </div>

                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                        {service.name}
                                    </div>
                                    <div style={{ fontSize: '15px' }}>
                                        <span>{convertMinsToHrsMins(service.duration)}</span> -
                                        {service.staffName === service.preferredStaff && (
                                            <span> <HeartTwoTone twoToneColor="#eb2f96" /></span>
                                        )}
                                        <span> {service.staffName}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </div>
                {appointmentDetail.notes && <div style={{ fontSize: "16px", marginTop: 20, textAlign: "start" }}>
                    <span style={{ fontWeight: "bold" }}>Note: </span>
                    <span style={{ color: "#006d75" }}>{appointmentDetail.notes}</span>
                </div>}

                {appointmentDetail.images && appointmentDetail.images.length > 0 && <div style={{ fontSize: "16px", marginTop: 20, textAlign: "start" }}>
                    <span style={{ fontWeight: "bold" }}>Images: </span>
                    <div><AppointmentImages images={appointmentDetail.images} /></div>
                </div>}


                {/* <Button
                        fill='outline'
                        size='large'
                        shape='rounded'
                        style={{ marginTop: 30, width: "130px" }}
                        onClick={() => {
                            window.scrollTo(0, 0)
                            if (window.history.length > 2) {
                                navigate(-1)
                            } else {
                                navigate('/')
                            }
                        }}
                    >
                        <LeftOutline /> Go Back
                    </Button> */}

                {(allowCreateAppointment && (appointmentDetail.status === "Confirmed" || appointmentDetail.status === "Checked-in")) && <div>
                    <Button
                        color='primary'
                        fill='outline'

                        shape='rounded'
                        style={{ marginTop: 30, width: "100%" }}
                        onClick={() => navigate(`/appointment/create?aid=${appointmentDetail._id}&isEdit=true&date=${appointmentDetail.date}`)}
                    >
                        <EditSOutline /> Edit Appointment
                    </Button>
                </div>}



            </div>

        </div>
    )
}

export default AppointmentDetail